export default __webpack_public_path__ + "static/media/icon-error.f90836ae.svg";